import i18n from '@/i18n'

export const localizedUrl = url => `${url}?lang=${i18n.global.locale.value}`